import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react'
import { IDoesFilterPassParams, IFilterParams } from 'ag-grid-community'
import BHSelect from '../inputs/BHSelect'

interface Props extends IFilterParams {
  children: React.ReactNode
}

const statuses = [
  '---',
  'Saved',
  'Pending',
  'Available',
  'Ordered',
  // 'Expired',
]

const QuoteStatusFilter = forwardRef<any, Props>((props, ref) => {
  const [selectedStatus, setSelectedStatus] =
    useState<Maybe<QuoteStatusOption>>(null)

  // expose AG Grid Filter Lifecycle callbacks
  useImperativeHandle(ref, () => {
    return {
      // doesFilterPass(params: IDoesFilterPassParams) {
      //   const { api, colDef, column, columnApi, context } = props
      //   const { node } = params

      //   // make sure each word passes separately, ie search for firstname, lastname
      //   let passed = true
      //   if (quoteStatusOption) {
      //     quoteStatusOption
      //       .toLowerCase()
      //       .split(' ')
      //       .forEach((filterWord) => {
      //         const value = props.valueGetter({
      //           api,
      //           colDef,
      //           column,
      //           columnApi,
      //           context,
      //           data: node.data,
      //           getValue: (field) => node.data[field],
      //           node,
      //         })

      //         if (value.toString().toLowerCase().indexOf(filterWord) < 0) {
      //           passed = false
      //         }
      //       })
      //   }

      //   return passed
      // },

      isFilterActive() {
        return selectedStatus !== null
      },

      getModel() {
        if (!this.isFilterActive()) {
          return null
        }

        return { value: selectedStatus }
      },

      setModel(model: any) {
        setSelectedStatus(model === null ? null : model.value)
      },
    }
  })

  const onChange = (selectedIndex: number) => {
    const status = statuses[selectedIndex] as QuoteStatusOption
    setSelectedStatus(status)
  }

  useEffect(() => {
    props.filterChangedCallback()
  }, [selectedStatus])

  return (
    <div className="p-4 w-[200px]" style={{ padding: 4, width: 200 }}>
      <BHSelect
        key="quoteStatus"
        title=""
        currentValue={statuses.indexOf(selectedStatus ?? '') ?? null}
        onChange={onChange}
        options={statuses.map((status, i) => ({ label: status, value: i }))}
      />
      {/* <div style={{ fontWeight: 'bold' }}>Custom Athlete Filter</div>
      <div>
        <input
          style={{ margin: '4 0 4 0' }}
          type="text"
          value={filterText}
          onChange={onChange}
          placeholder="Full name search..."
        />
      </div>
      <div style={{ marginTop: 20 }}>Michael</div>
      <div style={{ marginTop: 20 }}>
        Just to emphasise that anything can go in here, here is an image!!
      </div>
      <div>
        <img
          src="https://www.ag-grid.com/images/ag-Grid2-200.png"
          style={{
            width: 150,
            textAlign: 'center',
            padding: 10,
            margin: 10,
            border: '1px solid lightgrey',
          }}
        />
      </div> */}
    </div>
  )
})

QuoteStatusFilter.displayName = 'QuoteStatusFilter'

export default QuoteStatusFilter
